<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <ValidationObserver v-slot="{ invalid }">
          <form autocomplete="do-not-autofill">
            <card footer-classes="text-right">
              <div slot="header"><h4 class="card-title">Quick edit output</h4></div>
              <div class="row">
                <!-- Nome -->
                <ValidationProvider class="col-md-12" name="name" :rules="{ required: true, regex: /^\S{3,16}$/ }" v-slot="{ passed, failed }">
                  <base-input required v-model="outputObj.name" type="name" label="Nome" :class="[{ 'has-success': passed }, { 'has-danger': failed }]"> </base-input>
                </ValidationProvider>
                <div class="col-md-12 category form-category">* Required fields</div>
              </div>
              <template slot="footer">
                <div class="row">
                  <div class="col-6 flex">
                    <base-button size="sm" type="success" class="auto-m" @click="close">Chiudi</base-button>
                  </div>
                  <div class="col-6 flex">
                    <base-button size="sm" type="primary" class="auto-m" @click="saveGroup" :disabled="invalid">{{ existingOutput ? "Salva" : "Aggiungi" }}</base-button>
                  </div>
                </div>
              </template>
            </card>
          </form>
        </ValidationObserver>
      </card>
    </div>
  </div>
</template>
<script>
//import { Select, Option } from "element-ui";

export default {
  props: {
    existingOutput: Object,
  },
  //components: { [Option.name]: Option, [Select.name]: Select },
  data() {
    return {
      outputObj: {},
    };
  },
  methods: {
    submit() {
      console.log("Form has been submitted!");
    },
    saveGroup() {
      console.log("Salvo output", this.outputObj);
      this.$emit("save", this.outputObj);
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    if (this.existingOutput) {
      this.outputObj = JSON.parse(JSON.stringify(this.existingOutput));
    }
  },
};
</script>
